<script>
    // -- IMPORTS

    import { getLocalizedText, getProcessedMultilineText } from 'senselogic-gist';
    import AnimatedText from '../element/AnimatedText.svelte';
    import { languageTagStore } from '../../store/languageTagStore';
    import { textStore } from '../../store/textStore';
    import { getProcessedMultilineTranslatedText } from '$src/lib/base';
    import AnimatedContainer from '../element/AnimatedContainer.svelte';
    import Media from '../element/Media.svelte';

    // -- VARIABLES

    /** @type {{titleSlug?: string, subtitleSlug?: string, title?: string, subtitle?: string, description?: string, mediaPath?: string}} */
    let {
        titleSlug = '',
        subtitleSlug = '',
        title = '',
        subtitle = '',
        description = '',
        mediaPath = ''
    } = $props();
</script>

<style lang="stylus">
    // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .page-heading
    {
        width: 100%;
        padding-top: 5rem;

        display: flex;
        flex-direction: column;
        gap: 5rem;
        margin: 0 2rem;

        +media( desktop )
        {
            margin: 0;
        }
    }

    .page-heading-title,
    .page-heading-subtitle
    {
        width: 100%;

        line-height: 2.5rem;
        font-size: 2rem;
        font-weight: 400;
        letter-spacing: 0.16rem;
        text-align: left;
        text-transform: uppercase;

        +media( desktop )
        {
            line-height: 7.5rem;
            font-size: 6rem;
            font-weight: 250;
            letter-spacing: 0.48rem;
            text-align: center;
        }
    }

    .page-heading-subtitle
    {
        line-height: 2.25rem;
        font-size: 1.5rem;
        font-weight: 400;
        text-align: left;
        text-transform: none;

        +media( desktop )
        {
            line-height: 2.25rem;
            font-size: 1.5rem;
            letter-spacing: 0.03rem;
            text-align: center;
        }
    }

    .hero-image-container
    {
        width: 99dvw;
    }

    :global( .hero-image-container .hero-image )
    {
        height: 32.23rem;
        width: 100%;

        object-fit: cover;

        +media( desktop )
        {
            height: 44.875rem;
        }
    }

    .hub-description
    {
        text-transform: none;
    }
</style>

<div class="page-heading">
    {#if titleSlug}
        <h1 class="page-heading-title color-light-gold">
            <AnimatedText text={ getLocalizedText( $textStore[ titleSlug ], $languageTagStore ) } />
        </h1>
    {/if}
    {#if title}
        <h1 class="page-heading-title color-light-gold">
            <AnimatedText text={ getLocalizedText( title, $languageTagStore ) } />
        </h1>
    {/if}
    {#if subtitleSlug}
        <h6 class="page-heading-subtitle color-light-grey">
            <AnimatedText text={ getProcessedMultilineTranslatedText( $textStore[ subtitleSlug ], $languageTagStore ) } />
        </h6>
    {/if}
    {#if subtitle}
        <h6 class="page-heading-subtitle color-light-grey">
            <AnimatedText text={ getProcessedMultilineTranslatedText( subtitle, $languageTagStore ) } />
        </h6>
    {/if}

    {#if mediaPath}
        <div class="hero-image-container">
            <AnimatedContainer>
                <Media
                    mediaPath={ mediaPath }
                    mediaClass="hero-image"
                    isHeroSection={ true }
                />
            </AnimatedContainer>
        </div>
    {/if}

    {#if description}
        <p class="hub-description color-light-grey">
            <AnimatedText text={ getProcessedMultilineText( description, $languageTagStore ) } />
        </p>
    {/if}
</div>